import React, { useEffect } from 'react'
import { gql } from '@apollo/client'
import { gaLog, useStatsig } from '@/lib/statsigAndGa'
import { initializeApollo } from '../../lib/apolloClient'
import QUERY_RENTAL_MARKET_TRENDS from '../../graphqls/queryRentalMarketTrends.gql'
import { getIsMobile } from '../../lib/getDevice'
import { getIp } from '../../lib/getIp'
import { getCaOrZipData } from '../../lib/cityArea'
import MarketTrendsComponent from '../../components/marketTrends'

const MarketTrends = ({ isMobileDevice, marketData, filterBy }) => {
  useStatsig('renty_ai_page_loaded', { page: 'market-trend' }, isMobileDevice)
  useEffect(() => {
    // ga with statsig
    gaLog('renty_ai_page_loaded', {
      page: 'market-trend'
    })
  }, [])
  return (
    <MarketTrendsComponent
      isMobileDevice={isMobileDevice}
      marketData={marketData}
      filterBy={filterBy}
    />
  )
}

const getServerSideProps = async ({ req, res, query }) => {
  const userId = req.cookies.statsig_id
  const { slug = [] } = query
  const [cityPath, areaPath] = slug

  let marketData = null
  const apolloClient = initializeApollo(req)

  const {
    value: { city: cityName, area: areaName, areaLowcaseName, cityLowcaseName }
  } = getCaOrZipData(areaPath || cityPath, '')

  const filterBy = {
    city: cityName || '',
    area: areaName || '',
    cityPath: cityLowcaseName || '',
    areaPath: areaLowcaseName || ''
  }

  try {
    marketData = await apolloClient.query({
      query: gql`
        ${QUERY_RENTAL_MARKET_TRENDS}
      `,
      variables: {
        city: areaName ? null : cityName,
        area: areaName || null,
        neighborhood: cityName
      }
    })

    const { data } = marketData || {}
    const { queryRentalMarketTrends } = data || {}
    const { averageRent } = queryRentalMarketTrends || {}
    const { avgRent = null } = averageRent || {}

    if (marketData === null || !avgRent) {
      res.writeHead(302, {
        Location: '/'
      })
      res.end()
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error detail', error)
    marketData = {}
  }

  return {
    props: {
      marketData: marketData?.data || {},
      filterBy,
      isMobileDevice: getIsMobile(req),
      ip: getIp(req),
      uid: userId
    }
  }
}

export { getServerSideProps }
export default MarketTrends
